import { Spin } from "antd";
import React from "react";


const CalculationProgress = () => {

    return (
        <div className="step-content-item-header">
            <Spin />
            <h4>
                The system is processing your file...
            </h4>
            <small>We will email you when the process is complete.</small>
        </div>
    )
}

export default CalculationProgress;